
export const MAX_QUANTITY = 35

export const STATUS = {
  PENDING   : 'pending',
  CONFIRMED : 'confirmed',
  SCHEDULED : 'scheduled',
  RECEIVED  : 'received',
  CANCELLED : 'cancelled',
  EXPIRED   : 'expired'
}

export const SHIPPING_METHOD = {
  DROPOFF : 'dropoff',
  PICKUP  : 'pickup'
}

export const DROPOFF_LOCATION = {
  JAKARTA: {
    label   : 'Jakarta',
    value   : 'jakarta',
    address : 'Jl. Sisingamangaraja No.11-A, RT.2/RW.8, Gunung, Kec. Kby. Baru, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12120'
  },
  PALEMBANG: {
    label   : 'Palembang (Luxury Only)',
    value   : 'palembang',
    address : 'Jl. Slamet Riyadi No.67, 9 Ilir, Kecamatan Ilir Tim. II, Kota Palembang, Sumatera Selatan 30111'
  },
  BANDUNG: {
    label   : 'Bandung (Luxury Only)',
    value   : 'bandung',
    address : 'Paskal Hyper Square 23 Shopping Center. Basement 1. Kebon Jeruk, Andir, Kota Bandung, Jawa Barat 40181'
  },
  SURABAYA: {
    label   : 'Surabaya (Luxury Only)',
    value   : 'surabaya',
    address : 'Pakuwon Trade Center, G/F, D7-12, Puncak Indah Lontar 2, Surabaya, Jawa Timur 60123'
  }
}
